import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { t } from 'i18next'
import { useLazyQuery } from '@apollo/client';
import { GET_BOAT_SEAT_LAYOUT } from 'graphql/boat/queries';



export function BoatSeatLayoutDropdown({ value, onChange, onBlur, error, helperText }) {

  const [seatLayoutList, setSeatLayoutList] = useState(null)

  const [getSeatLayoutList, { loading: seatListLoading, error: seatListError }] = useLazyQuery(GET_BOAT_SEAT_LAYOUT, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      if (data.boatSeatLayout.length > 0) {
        setSeatLayoutList(data.boatSeatLayout)
      }
    },
  })

  // get Type List
  const getSeatLayouts = () => {
    getSeatLayoutList({
      variables: {
        "boatSeatLayoutId": null
      },
    })
  }
  useEffect(() => {
    getSeatLayouts();
  }, [seatLayoutList]);

  return (
    <>
      {seatListLoading && <div className="flex justify-center items-center bg-white py-5">Loading ....</div>}
      {seatListError && (
        <div className="flex justify-center items-center bg-white py-5">
          <div className="text-lg text-center">{t('Failed to fetch SeatList!')}</div>
        </div>
      )}
      {!seatListLoading && !seatListError && seatLayoutList?.length === 0 && (
        <div className="flex justify-center items-center bg-white py-5">
          <div className="text-lg text-center">{t('No SeatList found!')}</div>
        </div>
      )}
      {!seatListLoading && !seatListError && seatLayoutList?.length > 0 && (
        <select
          id="seat_layout"
          name="seat_layout"
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
        >
          <option value="" disabled> {t('Select Seat Layout')} </option>
          {seatLayoutList.map((seatLayout) => (
            <option key={seatLayout.layout_id} value={seatLayout.layout_id}>
              {seatLayout.description.en}
            </option>
          ))}
        </select>

      )}
      {error && <p className="text-error text-xs mt-1">
        {helperText}
      </p>}


    </>
  );
}